(()=>{
  if(window.__frpConfiguratorBound)return;
  window.__frpConfiguratorBound=true;
  const money=(cents,currency)=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency||'USD'}).format((Number(cents)||0)/100);
  const normalize=value=>String(value||'').trim().toLowerCase();
  let instance;
  const boot=()=>{
    const root=document.querySelector('[data-frp-configurator]');
    if(!root){instance?.abort.abort();instance=undefined;return;}
    if(instance?.root===root){instance.update();return;}
    instance?.abort.abort();
    const abort=new AbortController();
    const signal=abort.signal;
    const variants=JSON.parse(root.querySelector('[data-frp-variants]')?.textContent||'[]');
    const backgrounds=JSON.parse(root.querySelector('[data-frp-backgrounds]')?.textContent||'[]');
    const sceneImages=JSON.parse(root.querySelector('[data-frp-scene-images]')?.textContent||'{}');
    const form=root.querySelector('[data-frp-form]');
    const idInput=root.querySelector('[data-frp-variant-id]');
    const visual=root.querySelector('[data-frp-visual]');
    const productMedia=visual.querySelector('.frp-configurator__media-stack')||visual;
    const productImages=[...root.querySelectorAll('[data-frp-product-image]')];
    const sceneLayers=[...root.querySelectorAll('[data-frp-scene-image]')];
    const mobileProduct=root.querySelector('[data-frp-mobile-product-image]');
    const mobileScene=root.querySelector('[data-frp-mobile-scene-image]');
    // CHG-20261022-01: m3-configure 手机端步骤图跟随当前变体主图（不跟缩略图点击）
    const stepVisuals=[...document.querySelectorAll('[data-frp-step-visual] img')];
    const submit=root.querySelector('[data-frp-submit]');
    const submitLabel=root.querySelector('[data-frp-submit-label]');
    const status=root.querySelector('[data-frp-status]');
    const purchase=root.querySelector('.frp-configurator__purchase');
    let activeVariant=variants.find(v=>String(v.id)===idInput?.value)||variants[0];
    let currentProductImage=productImages[0];
    let currentProductUrl=activeVariant?.image||'';
    let currentSceneImage;
    let currentSceneUrl='';
    let productRequest=0;
    let sceneRequest=0;
    let frame;
    // CHG-20261022-02: 换色时背景和步骤图等新车图就绪后与首图一起换（原来背景先变、车图后到）
    let pendingVisual=null;
    const commitVisual=()=>{
      if(!pendingVisual)return;
      const {background,image}=pendingVisual;
      pendingVisual=null;
      root.style.setProperty('--frp-stage-background',background);
      if(image)stepVisuals.forEach(img=>{if(img.dataset.frpSrc!==image){img.dataset.frpSrc=image;img.src=image;}});
    };
    // 预加载与当前变体只差一个选项的变体主图（再点一下会看到的），点选时直接从缓存出图
    const preloadedVariantImages=new Map();
    const preloadVariantImages=()=>{
      variants.filter(variant=>variant.image&&!preloadedVariantImages.has(variant.image)&&variant.options.filter((value,index)=>value!==activeVariant?.options?.[index]).length===1).forEach(variant=>{
        const image=new Image();
        image.decoding='async';
        image.src=variant.image;
        preloadedVariantImages.set(variant.image,image);
      });
    };
    const modules=()=>[...document.querySelectorAll('[data-frp-configurator-module]')].filter(item=>!item.hidden);
    const options=()=>[...document.querySelectorAll('[data-frp-option]')];
    const extras=()=>[...document.querySelectorAll('[data-frp-accessory]')];
    const selectedColor=()=>document.querySelector('.frp-configurator__step--color [data-frp-option]:checked')?.value||'';
    const chosenOptions=()=>[...new Set(options().map(input=>Number(input.dataset.optionPosition)))].sort((a,b)=>a-b).map(position=>document.querySelector(`[data-frp-option][data-option-position="${position}"]:checked`)?.value||'');
    const sceneForColor=()=>Object.entries(sceneImages).find(([key])=>normalize(key)===normalize(selectedColor()))?.[1]||{};
    const updateGifts=()=>{
      document.querySelectorAll('[data-frp-gift-sets]').forEach(module=>{
        const index=Number(module.dataset.frpGiftOptionPosition)-1;
        const value=normalize(activeVariant?.options?.[index]);
        const sets=[...module.querySelectorAll('[data-frp-gift-set]')];
        const selected=value?sets.find(item=>normalize(item.dataset.frpGiftSet)===value):undefined;
        const hasContent=selected?.dataset.frpGiftContent==='true';
        sets.forEach(item=>{item.hidden=item!==selected||!hasContent;});
        module.hidden=!hasContent&&module.dataset.frpGiftEditor!=='true';
        module.dataset.frpGiftSceneImage=selected?.dataset.frpGiftImage||'';
        const placeholder=module.querySelector('[data-frp-gift-placeholder]');
        if(placeholder)placeholder.hidden=hasContent;
      });
    };
    const sceneUrlFor=active=>{
      if(active?.hasAttribute('data-frp-gift-sets'))return active.dataset.frpGiftSceneImage||'';
      const scene=active?.dataset.frpScene||'overview';
      return sceneForColor()[scene]||active?.getAttribute(`data-frp-scene-${normalize(selectedColor())}-image`)||active?.dataset.frpSceneDefaultImage||'';
    };
    const syncMobile=()=>{
      if(mobileProduct&&currentProductUrl&&mobileProduct.getAttribute('src')!==currentProductUrl)mobileProduct.src=currentProductUrl;
      if(!mobileScene)return;
      if(currentSceneUrl&&mobileScene.getAttribute('src')!==currentSceneUrl)mobileScene.src=currentSceneUrl;
      if(!currentSceneUrl)mobileScene.removeAttribute('src');
    };
    const setProductImage=url=>{
      const request=++productRequest;
      if(!url||url===currentProductUrl||productImages.length<2){commitVisual();return;}
      const next=productImages.find(item=>item!==currentProductImage);
      const activate=()=>{
        if(request!==productRequest)return;
        next.onload=null;
        commitVisual();
        next.classList.add('is-current');
        currentProductImage?.classList.remove('is-current');
        currentProductImage=next;
        currentProductUrl=url;
        syncMobile();
      };
      next.onload=activate;
      next.src=url;
      next.removeAttribute('srcset');
      if(next.complete&&next.naturalWidth)activate();
    };
    const updateScene=()=>{
      const active=modules().find(item=>item.dataset.frpScene===root.dataset.frpActiveScene);
      const scene=active?.dataset.frpScene||'overview';
      const url=sceneUrlFor(active);
      const setting=active?.dataset.frpSceneMode||'auto';
      const mode=setting==='product'||!url?'base':setting==='auto'?(scene==='options'||scene==='accessories'?'layer':'replace'):setting;
      const request=++sceneRequest;
      if(mode==='base'){
        root.dataset.frpSceneMode='base';
        sceneLayers.forEach(item=>item.classList.remove('is-current'));
        currentSceneImage=undefined;
        currentSceneUrl='';
        syncMobile();
        return;
      }
      if(url===currentSceneUrl){root.dataset.frpSceneMode=mode;syncMobile();return;}
      const next=sceneLayers.find(item=>item!==currentSceneImage);
      const activate=()=>{
        if(request!==sceneRequest)return;
        next.onload=null;
        root.dataset.frpSceneMode=mode;
        next.classList.add('is-current');
        currentSceneImage?.classList.remove('is-current');
        currentSceneImage=next;
        currentSceneUrl=url;
        syncMobile();
      };
      next.onload=activate;
      next.src=url;
      if(next.complete&&next.naturalWidth)activate();
    };
    const preloadNearby=()=>{
      const list=modules();
      const at=list.findIndex(item=>item.dataset.frpScene===root.dataset.frpActiveScene);
      [list[at],list[at+1]].filter(Boolean).forEach(item=>{
        const url=sceneUrlFor(item);
        if(url){const preload=new Image();preload.src=url;}
      });
    };
    const updatePrices=()=>{
      const base=Number(activeVariant?.price||0);
      const added=extras().filter(input=>input.checked).reduce((sum,input)=>sum+Number(input.dataset.price||0),0);
      document.querySelectorAll('[data-frp-total],[data-frp-summary-total]').forEach(item=>item.textContent=money(base+added,root.dataset.currency));
      document.querySelectorAll('[data-frp-base-price],[data-frp-price]').forEach(item=>item.textContent=money(base,root.dataset.currency));
      document.querySelectorAll('[data-frp-compare]').forEach(item=>{item.textContent=money(activeVariant?.compareAtPrice,root.dataset.currency);item.classList.toggle('is-hidden',!(activeVariant?.compareAtPrice>base));});
      const selectedAccessories=root.querySelectorAll('.frp-configurator__module--accessories [data-frp-accessory]:checked').length;
      document.querySelectorAll('[data-frp-accessory-count]').forEach(item=>item.textContent=selectedAccessories?`${selectedAccessories} selected`:'None');
      document.querySelectorAll('[data-frp-summary-variant]').forEach(item=>item.textContent=`${document.querySelector('.frp-configurator__module--overview h1')?.textContent.trim()||''} · ${activeVariant?.title||activeVariant?.options?.join(' / ')||''}`);
    };
    const updateVariant=()=>{
      const chosen=chosenOptions();
      const match=variants.find(variant=>variant.options.every((value,index)=>value===chosen[index]));
      if(!match)return;
      activeVariant=match;
      idInput.value=match.id;
      const background=backgrounds.find(item=>normalize(item.color)===normalize(selectedColor()))?.background;
      pendingVisual={background:background||root.dataset.frpDefaultBackground,image:match.image};
      const url=new URL(window.location.href);
      url.searchParams.set('variant',match.id);
      window.history.replaceState(window.history.state,'',url);
      root.querySelectorAll('[data-frp-color-link]').forEach(link=>{
        const target=new URL(link.getAttribute('href'),window.location.origin);
        if(target.origin===window.location.origin){target.searchParams.set('variant',match.id);link.href=target.href;}
      });
      setProductImage(match.image);
      if(preloadedVariantImages.size)preloadVariantImages();
      options().filter(input=>input.checked).forEach(input=>document.querySelectorAll(`[data-frp-current-option="${input.dataset.optionPosition}"]`).forEach(label=>label.textContent=input.value));
      if(submit){submit.disabled=!match.available;submitLabel.textContent=match.available?submitLabel.dataset.availableLabel:submitLabel.dataset.soldOutLabel;}
      document.querySelectorAll('[data-frp-summary-submit]').forEach(button=>button.disabled=!match.available);
      updatePrices();
      updateGifts();
      updateScene();
      schedule();
      preloadNearby();
    };
    const updateActiveScene=()=>{
      frame=undefined;
      const list=modules();
      const marker=window.matchMedia('(min-width: 990px)').matches?Math.min(window.innerHeight*.4,400):window.innerHeight*.5;
      const selected=[...list].reverse().find(item=>item.getBoundingClientRect().top<=marker)||list[0];
      const next=selected?.dataset.frpScene||'overview';
      if(root.dataset.frpActiveScene!==next){root.dataset.frpActiveScene=next;updateScene();preloadNearby();}
      const last=list.at(-1);
      const inPage=Boolean(last&&last.getBoundingClientRect().bottom>0);
      root.classList.toggle('is-in-view',inPage);
      root.classList.toggle('has-mobile-preview',window.matchMedia('(max-width: 989px)').matches&&inPage&&productMedia.getBoundingClientRect().bottom<=window.innerHeight*.15);
      const summary=document.querySelector('.frp-configurator__module--summary .frp-configurator__step--summary');
      root.classList.toggle('is-summary-reached',Boolean(summary&&summary.getBoundingClientRect().top<=window.innerHeight-(purchase?.getBoundingClientRect().height||0)));
    };
    const schedule=()=>{if(frame===undefined)frame=requestAnimationFrame(updateActiveScene);};
    document.addEventListener('change',event=>{
      if(event.target.matches('[data-frp-option]'))updateVariant();
      if(event.target.matches('[data-frp-accessory]'))updatePrices();
    },{signal});
    document.addEventListener('click',event=>{
      const thumb=event.target.closest('[data-frp-thumb]');
      if(thumb){root.querySelectorAll('[data-frp-thumb]').forEach(item=>item.classList.toggle('is-active',item===thumb));setProductImage(thumb.dataset.image);root.dataset.frpSceneMode='base';sceneLayers.forEach(item=>item.classList.remove('is-current'));currentSceneImage=undefined;currentSceneUrl='';syncMobile();}
      const opener=event.target.closest('[data-frp-dialog-open]');
      if(opener)document.getElementById(opener.dataset.frpDialogOpen)?.showModal();
      const closer=event.target.closest('[data-frp-dialog-close]');
      if(closer)closer.closest('dialog')?.close();
    },{signal});
    form?.addEventListener('submit',async event=>{
      event.preventDefault();
      if(!activeVariant?.available)return;
      const buttons=[submit,...document.querySelectorAll('[data-frp-summary-submit]')].filter(Boolean);
      buttons.forEach(button=>button.disabled=true);
      status.textContent='';
      const items=[{id:Number(activeVariant.id),quantity:1},...extras().filter(input=>input.checked).map(input=>({id:Number(input.value),quantity:1}))];
      try{
        const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const payload=await response.json();
        if(!response.ok)throw new Error(payload.description||payload.message||root.dataset.errorLabel);
        submitLabel.textContent=root.dataset.addedLabel;
        status.textContent=root.dataset.addedLabel;
        document.dispatchEvent(new CustomEvent('cart:update',{detail:{data:{didError:false}}}));
        setTimeout(()=>{submitLabel.textContent=submitLabel.dataset.availableLabel;buttons.forEach(button=>button.disabled=false)},1600);
      }catch(error){status.textContent=error.message||root.dataset.errorLabel;buttons.forEach(button=>button.disabled=false);}
    },{signal});
    window.addEventListener('scroll',schedule,{passive:true,signal});
    window.addEventListener('resize',schedule,{passive:true,signal});
    const refresh=()=>{updateVariant();schedule();};
    instance={root,abort,update:refresh,setScene:scene=>{root.dataset.frpActiveScene=scene;updateScene();preloadNearby();}};
    const incoming=new URL(window.location.href).searchParams;
    const requested=variants.find(item=>String(item.id)===incoming.get('variant'));
    if(requested)options().forEach(input=>{input.checked=input.value===requested.options[Number(input.dataset.optionPosition)-1];});
    refresh();
    syncMobile();
    // 不等 window load（第三方脚本会把 load 拖到 10 秒以上）：首图出来后用空闲时间预加载
    const startPreload=()=>{if('requestIdleCallback' in window)requestIdleCallback(preloadVariantImages,{timeout:1500});else setTimeout(preloadVariantImages,300);};
    if(!currentProductImage||currentProductImage.complete)startPreload();else currentProductImage.addEventListener('load',startPreload,{once:true,signal});
  };
  document.addEventListener('shopify:section:load',()=>requestAnimationFrame(boot));
  document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(boot));
  document.addEventListener('shopify:section:reorder',()=>requestAnimationFrame(boot));
  document.addEventListener('shopify:section:select',event=>{
    const module=event.target.querySelector?.('[data-frp-configurator-module]')||event.target.closest?.('[data-frp-configurator-module]');
    if(module)instance?.setScene(module.dataset.frpScene);
  });
  document.addEventListener('shopify:block:select',event=>{
    const module=event.target.closest?.('[data-frp-configurator-module]');
    if(module)instance?.setScene(module.dataset.frpScene);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
